import { PdFormField } from "./pd-form-field/PdFormField.js";
//#region src/pd-form-field/pd-form-field.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
var tag = "pd-form-field";
if (!customElements.get(tag)) customElements.define(tag, PdFormField);
//#endregion
export { PdFormField };
